import routeConfig from "../../../../../../../modules/routeConfig";
import productRoutes from "../../../../../modules/productRoutes";
import K1ApplicantsTable from "./pages/K1ApplicantsTable";
import K1ApplicantEdit from "./pages/K1ApplicantsEdit";

export default routeConfig(productRoutes([K1ApplicantsTable, K1ApplicantEdit]));
